import React from 'react';

import DefaultLayout from '../_layouts/default';

import MainContent from './MainContent';

import { AnimatedContainer } from './styles';
import { MAIN_CONTENT_ANIMATION } from './animations';

const Dashboard = (): JSX.Element => {
  return (
    <DefaultLayout>
      <AnimatedContainer variants={MAIN_CONTENT_ANIMATION}>
        <MainContent />
      </AnimatedContainer>
    </DefaultLayout>
  );
};

export default Dashboard;
